import { render, staticRenderFns } from "./PartnerDetailView.vue?vue&type=template&id=620ec8a5&scoped=true"
import script from "./PartnerDetailView.vue?vue&type=script&lang=ts"
export * from "./PartnerDetailView.vue?vue&type=script&lang=ts"
import style0 from "./PartnerDetailView.vue?vue&type=style&index=0&id=620ec8a5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620ec8a5",
  null
  
)

export default component.exports